module.exports = __webpack_public_path__ + "static/media/invoice_inactive.088e1366.svg";